import React from "react";
import { Button, ArrowLeftIcon, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedBtnWithIcons = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Outlined button with start and end icon"}
        value={
          '<Button variant={"outlined"} startIcon={<ArrowLeftIcon />} endIcon={<ArrowRightIcon />}>\n' +
          "            Label\n" +
          "          </Button>"
        }
      >
        <Button
          variant={"outlined"}
          startIcon={<ArrowLeftIcon />}
          endIcon={<ArrowRightIcon />}
        >
          Label
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedBtnWithIcons;
